<template>
    <div>
        <div v-if="loading" class="text-center" style="margin-top: 10em">
            <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <div v-else>
            <transition appear name="slide-fade">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <router-link to="/panel_usuarios" class="btn btn-orange rounded-pill">
                                <i class="bx bx-chevron-left"></i> Regresar
                            </router-link>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <h3 class="text-orange">Usuarios por agente</h3>
                        <hr />
                    </div>
                </div>
            </transition>
            <div class="card card-body">
                <div class="form-group">
                    <label>Agente</label>
                    <v-select v-model="agente" @input="get_resumen" label="nombre_completo" :options="agentes"></v-select>
                </div>
                <div>
                    <div class="row" v-if="agente == null | agente == ''">
                        <div class="col-lg-6">
                            <div class="card">
                                <div class="card-header">
                                    <h5 class="card-title">Usuarios por agentes</h5>
                                </div>
                                <div class="card-body">
                                    <div class="chart chart-sm">
                                        <apexchart type="donut" :options="chart_agentes.options"
                                            :series="chart_agentes.series"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card">
                                <div class="card-header">
                                    <h5 class="card-title">Usuarios por agentes Mes Actual</h5>
                                </div>
                                <div class="card-body">
                                    <div class="chart chart-sm">
                                        <apexchart type="donut" :options="chart_agentes_mes.options"
                                            :series="chart_agentes_mes.series"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="agente != null">
                        <div v-if="loading_resumen_usuarios" class="text-center mt-4">
                            <div class="lds-roller">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div v-else>
                            <transition appear name="slide-fade">
                                <div class="row">
                                    <div class="col-lg-5 d-flex align-items-stretch">
                                        <div class="card card-body">
                                            <div class="p-1">
                                                <apexchart type="bar" :options="chart_usuarios.options"
                                                    :series="chart_usuarios.series"></apexchart>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 d-flex align-items-stretch">
                                        <div class="card card-body">
                                            <div class="p-4">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div class="card card-body shadow p-1">
                                                            <h5 class="fw-bold text-orange">
                                                                Total de usuarios: {{ total_usuarios }}
                                                            </h5>
                                                        </div>
                                                        <div class="card card-body shadow p-1 mt-0">
                                                            <h5 class="fw-bold text-orange">
                                                                Total de usuarios por
                                                                {{ agente.nombre_completo }}:
                                                                {{ total_usuarios }}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-lg-12">
                                                        <label>Estado Usuario</label>
                                                        <!-- <label>Mes de registro</label> -->
                                                        <select v-model="estado" v-on:change="get_usuarios"
                                                            class="form-control">
                                                            <option value="null">Todos</option>
                                                            <option value="0">Interesado</option>
                                                            <option value="1">Pendiente</option>
                                                            <option value="3">Exitosa</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-lg-12">
                                                        <label>Periodo de Facturación</label>
                                                        <!-- <label>Mes de registro</label> -->
                                                        <input v-on:change="get_usuarios" v-model="fecha" type="month"
                                                            class="form-control" />
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <button class="btn btn-outline-primary btn-sm rounded-pill"
                                                            v-on:click="getLiquidacion($event)">
                                                            Liquidar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <transition appear name="slide-fade">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div v-if="loading_usuarios" class="text-center mt-4">
                                            <div class="lds-roller">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="card card-body">
                                                <div class="mt-3 mb-3 p-2 border text-orange bg-light">
                                                    <span class="fw-bold">Mes: <span v-if="fecha != null">{{ fecha
                                                    }}</span><span v-else>General</span>
                                                    </span>
                                                    -
                                                    <span class="fw-bold">Cantidad: {{ total_usuarios_reporte }}
                                                    </span>
                                                </div>
                                                <table class="table table-bordered table-condensed table-hover my_table_1">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 2%">#</th>
                                                            <th style="width: 20%">Nombre</th>
                                                            <th class="text-center" style="width: 9%">
                                                                Estado
                                                            </th>
                                                            <th class="text-center" style="width: 15%">
                                                                Agente
                                                            </th>
                                                            <th class="text-center" style="width: 10%">
                                                                Tipo Membresia
                                                            </th>
                                                            <th class="text-center" style="width: 15%">
                                                                Fecha de Corte
                                                            </th>
                                                            <th style="width: 15%">
                                                                Comision Usuario
                                                            </th>
                                                            <th class="text-center" style="width: 8%">
                                                                Opciones
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(usuario, index_usuario) in usuarios"
                                                            v-bind:key="index_usuario">
                                                            <td>{{ usuario.num }}</td>
                                                            <td>
                                                                <h5 class="text-orange fw-bold mb-0">
                                                                    {{ usuario.nombres + ' ' + usuario.apellidos }}
                                                                </h5>
                                                            </td>
                                                            <td class="text-center">
                                                                <span>
                                                                    <span v-if="usuario.estado_registro == 0"
                                                                        class="badge bg-primary fw-bold">Interesado</span>
                                                                    <span v-if="usuario.estado_registro == 1"
                                                                        class="badge bg-danger fw-bold">Pendiente</span>
                                                                    <span v-if="usuario.estado_registro == 2"
                                                                        class="badge bg-success fw-bold">Completa</span>
                                                                    <span v-if="usuario.estado_registro == 3"
                                                                        class="badge bg-warning fw-bold">Exitosa</span>
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div v-if="usuario.agente != null">
                                                                    <span class="text-uppercase">{{
                                                                        usuario.agente.usuario
                                                                    }}</span>
                                                                </div>
                                                                <small class="text-muted">
                                                                    {{ usuario.fecha_registro }}
                                                                </small>
                                                            </td>
                                                            <td class="text-center">
                                                                {{ usuario.membresia.tipo_membresia == 1 ? 'Anual' :
                                                                    'Semestral'
                                                                }}
                                                            </td>
                                                            <td class="text-center">
                                                                {{ usuario.fecha_corte }}
                                                            </td>
                                                            <td>
                                                                <div v-if="usuario.membresia.tipo_membresia == 1">
                                                                    {{ 30000 | currency }}
                                                                </div>
                                                                <div v-if="usuario.membresia.tipo_membresia == 2">
                                                                    {{ 15000 | currency }}
                                                                </div>
                                                            </td>
                                                            <td class="text-center">
                                                                <div class="dropdown">
                                                                    <a class="btn btn-outline-primary btn-sm rounded-pill dropdown-toggle"
                                                                        href="javascript:void(0)" role="button"
                                                                        id="dropdownMenuLink" data-bs-toggle="dropdown"
                                                                        aria-expanded="false">
                                                                        Opciones
                                                                    </a>

                                                                    <ul class="dropdown-menu dropdown-menu-end"
                                                                        aria-labelledby="dropdownMenuLink">
                                                                        <li>
                                                                            <router-link class="dropdown-item" v-bind:to="
                                                                                '/usuario/info_basica/' +
                                                                                usuario.id_usuario
                                                                            ">
                                                                                Información básica
                                                                            </router-link>
                                                                        </li>
                                                                        <li>
                                                                            <router-link class="dropdown-item" v-bind:to="
                                                                                '/beneficiarios/' + usuario.id_usuario
                                                                            ">
                                                                                Beneficiarios
                                                                            </router-link>
                                                                        </li>
                                                                        <li>
                                                                            <router-link class="dropdown-item" v-bind:to="
                                                                                '/pago/' + usuario.id_usuario
                                                                            ">
                                                                                Pago
                                                                            </router-link>
                                                                        </li>
                                                                        <li>
                                                                            <router-link class="dropdown-item" v-bind:to="
                                                                                '/anexos_membresia/' +
                                                                                usuario.id_usuario
                                                                            ">
                                                                                Soporte de pago
                                                                            </router-link>
                                                                        </li>
                                                                        <li v-if="session.usuario.perfil == 0">
                                                                            <a v-on:click="
                                                                                show_modal_eliminar(index_usuario)
                                                                            " href="javascript:void(0)"
                                                                                class="dropdown-item text-danger">Eliminar</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal name="modal_liquidacion" :adaptive="true" height="auto">
            <div class="card m-4" id="element-to-convert">
                <div class="card-header">
                    <h2 class="fw-bold text-orange">Liquidacion Usuarios</h2>
                </div>
                <div class="card-body" v-if="agente != null" style="height:70vh;overflow-y:scroll">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Agente:</h2>
                            <h4>{{ agente.nombre_completo }}</h4>
                            <br>
                        </div>
                        <div class="col-md-6">
                            <h2>Fecha generación:</h2>
                            <h4>{{ today.getFullYear() + '-' + today.getMonth() + '-' + today.getDate() }}</h4>
                            <br>
                        </div>
                        <div class="col-md-6">
                            <h2>Fecha liquidada:</h2>
                            <h4>{{ fecha }}</h4>
                            <br>
                        </div>
                    </div>
                    <h2>Detalle liquidación</h2>
                    <table class="table table-bordered table-condensed table-hover my_table_1">
                        <thead>
                            <tr>
                                <th style="width: 2%">#</th>
                                <th style="width: 20%">Nombre</th>
                                <th class="text-center" style="width: 10%">
                                    Tipo Membresia
                                </th>
                                <th style="width: 15%">
                                    Comision Usuario
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(usuario, index_usuario) in usuarios" v-bind:key="index_usuario">
                                <td>{{ usuario.num }}</td>
                                <td>
                                    <h5 class="text-orange fw-bold mb-0">
                                        {{ usuario.nombres + ' ' + usuario.apellidos }}
                                    </h5>
                                </td>
                                <td class="text-center">
                                    {{ usuario.membresia.tipo_membresia == 1 ? 'Anual' : 'Semestral'
                                    }}
                                </td>
                                <td>
                                    <div v-if="usuario.membresia.tipo_membresia == 1">
                                        {{ 30000 | currency }}
                                    </div>
                                    <div v-if="usuario.membresia.tipo_membresia == 2">
                                        {{ 15000 | currency }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <h2>Total a Pagar:</h2>
                    <h4>
                        {{ total_liquidacion | currency }}
                    </h4>
                    <hr />
                    <div class="text-end">
                        <button class="btn btn-outline-secondary rounded-pill" @click="exportToPDF()">Export to PDF</button>
                        <button @click="$modal.hide('modal_liquidacion')" class="btn btn-outline-secondary rounded-pill">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="modal_eliminar" :adaptive="true" height="auto">
            <div class="card m-4">
                <div class="card-header">
                    <h4 class="fw-bold text-danger">Eliminar usuario</h4>
                </div>
                <div class="card-body">
                    <div v-if="index_select != null" class="text-danger">
                        ¿Desea eliminar al usuario
                        <strong>{{ usuarios[index_select].nombres }}
                            {{ usuarios[index_select].apellidos }}</strong>?
                    </div>
                    <hr />
                    <div class="text-end">
                        <button @click="eliminar" class="btn btn-danger rounded-pill">
                            Sí
                        </button>
                        <button @click="$modal.hide('modal_eliminar')" class="btn btn-outline-secondary rounded-pill">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import html2pdf from "html2pdf.js";
export default {
    name: "Panel_agentes",
    metaInfo: {
        title: "Panel de agentes - Reddy Backoffice",
    },
    data() {
        return {
            loading: true,
            loading_resumen_usuarios: false,
            loading_usuarios: false,
            agentes: [],
            agente: null,
            chart_agentes: {
                options: {
                    plotOptions: {
                        pie: {
                            size: 200,
                            expandOnClick: true,
                            donut: {
                                labels: {
                                    show: true,
                                    total: {
                                        show: true
                                    }
                                }
                            }
                        }
                    },
                    labels: []
                },
                series: [44, 55, 13, 33],
            },
            chart_agentes_mes: {
                options: {
                    plotOptions: {
                        pie: {
                            size: 200,
                            expandOnClick: true,
                            donut: {
                                labels: {
                                    show: true,
                                    total: {
                                        show: true
                                    }
                                }
                            }
                        }
                    },
                    labels: []
                },
                series: [44, 55, 13, 33],
            },
            chart_usuarios: {
                options: {
                    plotOptions: {
                        bar: {
                            borderRadius: 10,
                            distributed: true,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    xaxis: {
                        categories: ["Interesados", "Pendientes", "Exitosas"],
                        axisBorder: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    colors: ["#6296FE", "#FF4D4D", "#FFC100", "#39BB00"],
                },
                series: [
                    {
                        name: "Usuarios",
                        data: [0, 0, 0, 0],
                    },
                ],
            },
            today: new Date(),
            total_usuarios: 0,
            vista: 2,
            index_select: null,
            usuarios: [],
            estado: null,
            fecha: null,
            total_usuarios_reporte: 0,
            total_liquidacion: 0,
        };
    },
    props: {
        session: Object,
    },
    created: function () {
        if (this.session.usuario.perfil != 0) {
            this.$router.push("/usuarios");
        }
        var agente_filtro = localStorage.getItem("agente_usuarios_filtro");
        if (agente_filtro != undefined) {
            this.agente = JSON.parse(agente_filtro);
            this.get_resumen();
            this.get_usuarios();
        }
        this.get_agentes();
        this.get_chart_data();
        this.get_chart_mes_data();
        this.chart_agentes.options.labels = JSON.parse(localStorage.getItem('agente_labels'))
        this.chart_agentes_mes.options.labels = JSON.parse(localStorage.getItem('agente_labels_mes'))
    },
    methods: {
        hasHistory() { return window.history.length > 2 },
        exportToPDF() {
            html2pdf(document.getElementById("element-to-convert"), {
                margin: 1,
                filename: "liquidacion.pdf",
            });
        },
        get_agentes: function () {
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                    agentes: 1,
                },
            };
            axios
                .get(this.$base_url + "admin/usuarios", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.agentes = response.data.data.usuarios;
                    this.loading = false;
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        get_resumen: function () {
            if (this.agente == null) {
                return false;
            }
            this.loading_resumen_usuarios = true;
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                    id_usuario: this.agente.id_usuario,
                },
            };
            axios
                .get(this.$base_url + "clientes/resumen_clientes", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.chart_usuarios.series[0].data = response.data.data.chart;
                    this.total_usuarios = response.data.data.total;
                    this.loading_resumen_usuarios = false;
                    this.get_usuarios();
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        get_usuarios: function () {
            this.loading_usuarios = true;
            this.index_select = null;
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            localStorage.setItem("agente_usuarios_filtro", JSON.stringify(this.agente));
            let config = {
                headers: headers,
                params: {
                    id_usuario: this.agente.id_usuario,
                    fecha: this.fecha,
                    estado: this.estado,
                },
            };
            axios
                .get(this.$base_url + "clientes/clientes", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.usuarios = response.data.data.usuarios;
                    this.total_usuarios_reporte = response.data.data.total_usuarios;
                    this.loading_usuarios = false;
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        get_chart_data: function () {
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                },
            };
            axios
                .get(this.$base_url + "clientes/chart_usuarios_agentes", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.chart_agentes.series = response.data.values;
                    this.chart_agentes.options.labels = response.data.nombres;
                    localStorage.setItem('agente_labels', JSON.stringify(response.data.nombres));
                    console.log(response.data)
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        get_chart_mes_data: function () {
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                },
            };
            axios
                .get(this.$base_url + "clientes/chart_usuarios_agentes_mes", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: 'No hay informacion para mostrar En el grafico Mensual',
                        });
                    }
                    this.chart_agentes_mes.series = response.data.values;
                    this.chart_agentes_mes.options.labels = response.data.nombres;
                    localStorage.setItem('agente_labels_mes', JSON.stringify(response.data.nombres));
                    console.log(response.data)
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        getLiquidacion: function () {
            this.total_liquidacion = 0;
            if (this.fecha == null || this.estado != 3) {
                this.$notify({
                    type: "error",
                    group: "foo",
                    title: "Ups!",
                    text: "Solo se pueden liquidar los Usuarios Exitosos con periodo seleccionado",
                });
            } else {
                let usuarios = [];
                this.usuarios.forEach(usuario => {
                    let newUsuario = usuario;
                    if (newUsuario.membresia.tipo_membresia == 1) {
                        newUsuario.liquidacion_usuario = 30000;
                    } else if (newUsuario.membresia.tipo_membresia == 2) {
                        newUsuario.liquidacion_usuario = 15000;
                    }

                    newUsuario.liquidacion_total_usuario = newUsuario.liquidacion_usuario;
                    this.total_liquidacion += newUsuario.liquidacion_total_usuario;
                    usuarios.push(newUsuario);
                });
                this.usuarios = usuarios;
                console.log(this.usuarios)
                console.log(this.total_liquidacion)
                this.$modal.show("modal_liquidacion");
            }
        },
        show_modal_eliminar: function (index) {
            this.index_select = index;
            this.$modal.show("modal_eliminar");
        },
        eliminar: function () {
            const vm = this;
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            var params = {
                id_usuario: this.usuarios[this.index_select].id_usuario,
            };
            axios
                .post(this.$base_url + "clientes/eliminar_usuario", params, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        vm.$notify({
                            type: "error",
                            group: "foo",
                            title: "Error",
                            text: response.data.message,
                        });
                    } else {
                        vm.$notify({
                            type: "success",
                            group: "foo",
                            title: "Eliminado!",
                            text: response.data.message,
                        });
                    }
                    vm.index_select = null;
                    vm.$modal.hide("modal_eliminar");
                    vm.get_usuarios();
                })
                .catch(
                    (error) =>
                        vm.$notify({
                            type: "error",
                            group: "foo",
                            title: "Important message",
                            text: error,
                        }),
                    (vm.loading = false)
                )
                .finally();
        },
    },
    watch: {
        chart_agentes() {
            this.get_chart_data()
        }
    },
    mounted: function () { },
};
</script>